module.exports = __webpack_public_path__ + "img/zodiac-hustle-thumbnail.8a2c0fc0.jpg";